import { Requiredness } from "../enumerations";


export abstract class Requirement {
	public static readonly $type = {
		DataFieldTemplate: "Requirement",
		ComponentTemplate: "Requirement"
	};
	public readonly $type: string = Requirement.$type.DataFieldTemplate;

	public id?: number;
	public requiredness!: Requiredness;
}
